import { Link, useNavigate } from "react-router-dom"

const pnd_icon = <svg xmlns="http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd" aria-hidden="true"
	strokeWidth={.5} fillRule="evenodd" imageRendering={"optimizeQuality"} textRendering={"geometricPrecision.replace"}
	shapeRendering={"geometricPrecision"}
	clipRule={'evenodd'} viewBox="0 0 500 500" version="1.1" className='w-20 h-20 group-hover:text-main' stroke="black" fill="currentColor"
/* style={{"shape-rendering":"geometricPrecision", "text-rendering":"geometricPrecision.replace",
"image-rendering":"optimizeQuality", "fill-rule":"evenodd" ,"clip-rule":"evenodd"}} */ ><g>
		<path className="st0" d="M207.5,7.5c42.7,0,85.3,0,128,0c0,10.7,0,21.3,0,32c8,0,16,0,24,0c0,21.3,0,42.7,0,64c5.3,0,10.7,0,16,0
		c-0.2,54,0,108,0.5,162c5,11.3,10,22.7,15,34c0.5-54.7,0.7-109.3,0.5-164c5.3,0,10.7,0,16,0c0-10.7,0-21.3,0-32c-5.3,0-10.7,0-16,0
		c-0.2-11.7,0-23.3,0.5-35c9.8-33.1,31.9-47.9,66.5-44.5c24.1,5.5,39,20.3,44.5,44.5c0.5,11.7,0.7,23.3,0.5,35c-5.3,0-10.7,0-16,0
		c0,10.7,0,21.3,0,32c5.3,0,10.7,0,16,0c0.2,82,0,164-0.5,246c-3.1,22.5-14,40-32.5,52.5c-4.7,2.2-9.5,4.1-14.5,5.5
		c-0.5,16-0.7,32-0.5,48c16,0,32,0,48,0c0,5.3,0,10.7,0,16c-165.3,0-330.7,0-496,0c-2.1-26.5,8.4-46.2,31.5-59
		c0.5-49.7,0.7-99.3,0.5-149c21.3,0,42.7,0,64,0c0-10.7,0-21.3,0-32c21.3,0,42.7,0,64,0c0-53.3,0-106.7,0-160c5.3,0,10.7,0,16,0
		c0-21.3,0-42.7,0-64c8,0,16,0,24,0C207.5,28.8,207.5,18.2,207.5,7.5z M223.5,23.5c32,0,64,0,96,0c0,5.3,0,10.7,0,16
		c-32,0-64,0-96,0C223.5,34.2,223.5,28.8,223.5,23.5z M439.5,40.5c31.8-0.6,47.8,15.1,48,47c-26.7,0-53.3,0-80,0
		C406.5,63.6,417.1,47.9,439.5,40.5z M199.5,55.5c48,0,96,0,144,0c0,16,0,32,0,48c-5.3,0-10.7,0-16,0c0-10.7,0-21.3,0-32
		c-5.3,0-10.7,0-16,0c0,10.7,0,21.3,0,32c-5.3,0-10.7,0-16,0c0-10.7,0-21.3,0-32c-5.3,0-10.7,0-16,0c0,10.7,0,21.3,0,32
		c-5.3,0-10.7,0-16,0c0-10.7,0-21.3,0-32c-5.3,0-10.7,0-16,0c0,10.7,0,21.3,0,32c-5.3,0-10.7,0-16,0c0-10.7,0-21.3,0-32
		c-5.3,0-10.7,0-16,0c0,10.7,0,21.3,0,32c-5.3,0-10.7,0-16,0C199.5,87.5,199.5,71.5,199.5,55.5z M423.5,103.5c5.3,0,10.7,0,16,0
		c0,10.7,0,21.3,0,32c-5.3,0-10.7,0-16,0C423.5,124.8,423.5,114.2,423.5,103.5z M455.5,103.5c5.3,0,10.7,0,16,0c0,10.7,0,21.3,0,32
		c-5.3,0-10.7,0-16,0C455.5,124.8,455.5,114.2,455.5,103.5z M183.5,119.5c58.7,0,117.3,0,176,0c0,40,0,80,0,120c-5.3,0-10.7,0-16,0
		c0-13.3,0-26.7,0-40c-48,0-96,0-144,0c0,16,0,32,0,48c45-0.2,90,0,135,0.5c-18.6,47.6-42,92.6-70,135c26.3,0.5,52.7,0.7,79,0.5
		c0.3,18.3,0,36.7-1,55c-11.4-10.8-25.1-16.1-41-16c-9.2-25.3-27.2-38.3-54-39c0-40,0-80,0-120c-21.3,0-42.7,0-64,0
		C183.5,215.5,183.5,167.5,183.5,119.5z M407.5,151.5c26.7,0,53.3,0,80,0c0.2,54.7,0,109.3-0.5,164c-17.1-20.7-37.9-25.5-62.5-14.5
		c-6.1,4.1-11.6,9-16.5,14.5C407.5,260.8,407.3,206.2,407.5,151.5z M215.5,215.5c37.3,0,74.7,0,112,0c0,5.3,0,10.7,0,16
		c-37.3,0-74.7,0-112,0C215.5,226.2,215.5,220.8,215.5,215.5z M349.5,255.5c1.5-0.3,2.8,0.1,4,1c14.8,38.7,33.1,75.5,55,110.5
		c-16.3,0.5-32.7,0.7-49,0.5c-0.2-9,0-18,0.5-27c6.8-4.8,13.7-9.7,20.5-14.5c-3-4.8-6.3-9.3-10-13.5c-3.4,2.5-6.9,4.8-10.5,7
		c-0.5-5.3-0.7-10.7-0.5-16c-5.3,0-10.7,0-16,0c0.2,11.7,0,23.3-0.5,35c-3-3.2-6.2-6.2-9.5-9c-4.3,3.7-8.3,7.7-12,12
		c7,7.5,14.2,14.8,21.5,22c0.5,1.3,0.7,2.6,0.5,4c-16.3,0.2-32.7,0-49-0.5C316.7,331.8,335,294.6,349.5,255.5z M119.5,279.5
		c37.3,0,74.7,0,112,0c0.3,35.3,0,70.7-1,106c-19.2,6.1-31.5,18.8-37,38c-7.2-0.3-14.4,0.1-21.5,1c-8.2-15.5-20.7-26-37.5-31.5
		c-4.9-1.2-9.9-1.8-15-1.5C119.5,354.2,119.5,316.8,119.5,279.5z M55.5,311.5c16,0,32,0,48,0c0.3,27.3,0,54.7-1,82
		c-5,1.9-9.9,4.3-14.5,7c-0.5-3-0.7-6-0.5-9c-5.3,0-10.7,0-16,0c0,5.3,0,10.7,0,16c2.7-0.2,5.4,0,8,0.5c-9,8.6-14.4,19.1-16,31.5
		c-2.7,0-5.3,0-8,0C55.5,396.8,55.5,354.2,55.5,311.5z M440.5,312.5c15.8-1.4,28,4.6,36.5,18c10.7,20.6,12.4,41.9,5,64
		c-5.2,13.2-14.4,22.4-27.5,27.5c-16.8,1.9-29.3-4.6-37.5-19.5c-3.3-5.9-5.8-12-7.5-18.5c9.7-0.3,19.3-0.7,29-1
		c-9.2-13.6-17.6-27.8-25-42.5C418.5,327.2,427.5,317.9,440.5,312.5z M359.5,383.5c11,0,22,0,33,0c3.3,21.7,13.9,38.5,32,50.5
		c4.7,2.2,9.5,4.1,14.5,5.5c0.5,16,0.7,32,0.5,48c-26.7,0-53.3,0-80,0C359.5,452.8,359.5,418.2,359.5,383.5z M239.5,400.5
		c29.2-1.2,45.5,12.8,49,42c23.2-6.5,40.4,0.9,51.5,22c2.2,7.5,3.4,15.2,3.5,23c-106,0-212,0-318,0c3.7-16.2,13.7-26.4,30-30.5
		c8-0.7,16-0.5,24,0.5c-2.2-24.9,8.5-41.1,32-48.5c27.3-2,43.6,10.5,49,37.5c7.1-3.7,14.6-6,22.5-7c8.3,1.3,16.5,3.3,24.5,6
		C207.2,422.4,217.8,407.4,239.5,400.5z"/>
	</g>
	<g>
		<path className="st1" d="M199.5,135.5c48,0,96,0,144,0c0,16,0,32,0,48c-48,0-96,0-144,0C199.5,167.5,199.5,151.5,199.5,135.5z
		 M215.5,151.5c0,5.3,0,10.7,0,16c37.3,0,74.7,0,112,0c0-5.3,0-10.7,0-16C290.2,151.5,252.8,151.5,215.5,151.5z"/>
	</g>
	<g>
		<path className="st1" d="M423.5,167.5c5.3,0,10.7,0,16,0c0,5.3,0,10.7,0,16c-5.3,0-10.7,0-16,0C423.5,178.2,423.5,172.8,423.5,167.5z"
		/>
	</g>
	<g>
		<path className="st1" d="M455.5,167.5c5.3,0,10.7,0,16,0c0,5.3,0,10.7,0,16c-5.3,0-10.7,0-16,0C455.5,178.2,455.5,172.8,455.5,167.5z"
		/>
	</g>
	<g>
		<path className="st1" d="M423.5,199.5c5.3,0,10.7,0,16,0c0,5.3,0,10.7,0,16c-5.3,0-10.7,0-16,0C423.5,210.2,423.5,204.8,423.5,199.5z"
		/>
	</g>
	<g>
		<path className="st1" d="M455.5,199.5c5.3,0,10.7,0,16,0c0,5.3,0,10.7,0,16c-5.3,0-10.7,0-16,0C455.5,210.2,455.5,204.8,455.5,199.5z"
		/>
	</g>
	<g>
		<path className="st1" d="M423.5,231.5c5.3,0,10.7,0,16,0c0,5.3,0,10.7,0,16c-5.3,0-10.7,0-16,0C423.5,242.2,423.5,236.8,423.5,231.5z"
		/>
	</g>
	<g>
		<path className="st1" d="M455.5,231.5c5.3,0,10.7,0,16,0c0,5.3,0,10.7,0,16c-5.3,0-10.7,0-16,0C455.5,242.2,455.5,236.8,455.5,231.5z"
		/>
	</g>
	<g>
		<path className="st1" d="M423.5,263.5c5.3,0,10.7,0,16,0c0,5.3,0,10.7,0,16c-5.3,0-10.7,0-16,0C423.5,274.2,423.5,268.8,423.5,263.5z"
		/>
	</g>
	<g>
		<path className="st1" d="M455.5,263.5c5.3,0,10.7,0,16,0c0,5.3,0,10.7,0,16c-5.3,0-10.7,0-16,0C455.5,274.2,455.5,268.8,455.5,263.5z"
		/>
	</g>
	<g>
		<path className="st1" d="M135.5,295.5c5.3,0,10.7,0,16,0c0,5.3,0,10.7,0,16c-5.3,0-10.7,0-16,0C135.5,306.2,135.5,300.8,135.5,295.5z"
		/>
	</g>
	<g>
		<path className="st1" d="M167.5,295.5c5.3,0,10.7,0,16,0c0,5.3,0,10.7,0,16c-5.3,0-10.7,0-16,0C167.5,306.2,167.5,300.8,167.5,295.5z"
		/>
	</g>
	<g>
		<path className="st1" d="M199.5,295.5c5.3,0,10.7,0,16,0c0,5.3,0,10.7,0,16c-5.3,0-10.7,0-16,0C199.5,306.2,199.5,300.8,199.5,295.5z"
		/>
	</g>
	<g>
		<path className="st1" d="M71.5,327.5c5.3,0,10.7,0,16,0c0,5.3,0,10.7,0,16c-5.3,0-10.7,0-16,0C71.5,338.2,71.5,332.8,71.5,327.5z" />
	</g>
	<g>
		<path className="st1" d="M135.5,327.5c5.3,0,10.7,0,16,0c0,5.3,0,10.7,0,16c-5.3,0-10.7,0-16,0C135.5,338.2,135.5,332.8,135.5,327.5z"
		/>
	</g>
	<g>
		<path className="st1" d="M167.5,327.5c5.3,0,10.7,0,16,0c0,5.3,0,10.7,0,16c-5.3,0-10.7,0-16,0C167.5,338.2,167.5,332.8,167.5,327.5z"
		/>
	</g>
	<g>
		<path className="st1" d="M199.5,327.5c5.3,0,10.7,0,16,0c0,5.3,0,10.7,0,16c-5.3,0-10.7,0-16,0C199.5,338.2,199.5,332.8,199.5,327.5z"
		/>
	</g>
	<g>
		<path className="st1" d="M71.5,359.5c5.3,0,10.7,0,16,0c0,5.3,0,10.7,0,16c-5.3,0-10.7,0-16,0C71.5,370.2,71.5,364.8,71.5,359.5z" />
	</g>
	<g>
		<path className="st1" d="M135.5,359.5c5.3,0,10.7,0,16,0c0,5.3,0,10.7,0,16c-5.3,0-10.7,0-16,0C135.5,370.2,135.5,364.8,135.5,359.5z"
		/>
	</g>
	<g>
		<path className="st1" d="M167.5,359.5c5.3,0,10.7,0,16,0c0,5.3,0,10.7,0,16c-5.3,0-10.7,0-16,0C167.5,370.2,167.5,364.8,167.5,359.5z"
		/>
	</g>
	<g>
		<path className="st1" d="M199.5,359.5c5.3,0,10.7,0,16,0c0,5.3,0,10.7,0,16c-5.3,0-10.7,0-16,0C199.5,370.2,199.5,364.8,199.5,359.5z"
		/>
	</g>
</svg>
const soft_icon = (<svg xmlns="http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd" aria-hidden="true"
	strokeWidth={.5} fillRule="evenodd" imageRendering={"optimizeQuality"} textRendering={"geometricPrecision.replace"}
	shapeRendering={"geometricPrecision"}
	clipRule={'evenodd'} viewBox="0 0 500 500" version="1.1" className='w-20 h-20 group-hover:text-main' stroke="black" fill="currentColor"
/* style={{"shape-rendering":"geometricPrecision", "text-rendering":"geometricPrecision.replace",
"image-rendering":"optimizeQuality", "fill-rule":"evenodd" ,"clip-rule":"evenodd"}} */ ><g>
		<path className="st0" d="M32.5,15.5c148.7-0.2,297.3,0,446,0.5c8.2,2.8,13.7,8.3,16.5,16.5c1,123.1,0.7,246.1-1,369
		c-3.3,6.6-8.5,11.1-15.5,13.5c-57,0.5-114,0.7-171,0.5c6,21.3,12,42.7,18,64c8.7,0,17.3,0,26,0c0,5.3,0,10.7,0,16
		c-64,0-128,0-192,0c0-5.3,0-10.7,0-16c8.7,0,17.3,0,26,0c6-21.3,12-42.7,18-64c-57,0.2-114,0-171-0.5c-7-2.4-12.2-6.9-15.5-13.5
		c-1.7-122.9-2-245.9-1-369C19,24.3,24.5,18.6,32.5,15.5z M39.5,31.5c144-0.2,288,0,432,0.5c4.5,0.5,7,3,7.5,7.5
		c0.5,104,0.7,208,0.5,312c-149.3,0-298.7,0-448,0c-0.2-104,0-208,0.5-312C32.7,35,35.2,32.3,39.5,31.5z M31.5,367.5
		c149.3,0,298.7,0,448,0c0.2,8,0,16-0.5,24c-0.5,4.5-3,7-7.5,7.5c-144,0.7-288,0.7-432,0c-4.5-0.5-7-3-7.5-7.5
		C31.5,383.5,31.3,375.5,31.5,367.5z M221.5,415.5c22.7,0,45.3,0,68,0c6,21.3,12,42.7,18,64c-34.7,0-69.3,0-104,0
		C209.5,458.2,215.5,436.8,221.5,415.5z"/>
	</g>
	<g>
		<path className="st1" d="M169.5,47.5c14.7-0.2,29.3,0,44,0.5c5.4,10.9,10,22.1,14,33.5c5.6,1.6,11.1,3.6,16.5,6
		c10.6-4,21.1-8.2,31.5-12.5c1.3-0.7,2.7-0.7,4,0c7.2,7.2,14.3,14.3,21.5,21.5c0.7,1,0.7,2,0,3c-3.2,3.2-6.3,6.3-9.5,9.5
		c-0.7,0.7-1.3,0.7-2,0c-4.9-5.4-10.2-10.3-16-14.5c-10,3.7-19.8,7.7-29.5,12c-9.4-4.1-18.9-8.1-28.5-12c-4.8-10.1-9.5-20.3-14-30.5
		c-6.7-0.7-13.3-0.7-20,0c-4.5,9.8-8.8,19.6-13,29.5c-9.7,4.6-19.5,9-29.5,13c-9.1-4-18.2-7.9-27.5-11.5c-1.3-0.7-2.7-0.7-4,0
		c-4.9,4.4-9.3,9.2-13,14.5c3.7,10,7.7,19.8,12,29.5c-4.1,9.4-8.1,18.9-12,28.5c-10.1,4.8-20.3,9.5-30.5,14c-0.7,6.7-0.7,13.3,0,20
		c9.8,4.5,19.6,8.8,29.5,13c4.6,9.7,9,19.5,13,29.5c-4,9.1-7.9,18.2-11.5,27.5c-0.7,1.3-0.7,2.7,0,4c4.4,4.9,9.2,9.3,14.5,13
		c10-3.7,19.8-7.7,29.5-12c8.1,3.6,16.3,7.1,24.5,10.5c-2.4,5.1-4.8,10.3-7,15.5c-5.9-2.2-11.7-4.6-17.5-7
		c-9.5,3.8-19,7.7-28.5,11.5c-2.3,1.1-4.6,1.5-7,1c-9.5-9.5-19-19-28.5-28.5c-0.7-1.3-0.7-2.7,0-4c4.3-10.4,8.5-20.9,12.5-31.5
		c-2.4-5.4-4.4-10.9-6-16.5c-11.3-4.4-22.4-9-33.5-14c-0.7-14.7-0.7-29.3,0-44c11.1-5,22.2-9.6,33.5-14c1.6-5.6,3.6-11.1,6-16.5
		c-4-10.6-8.2-21.1-12.5-31.5c-0.7-1.3-0.7-2.7,0-4c9.5-9.5,19-19,28.5-28.5c2.4-0.5,4.7-0.2,7,1c9.5,3.8,19,7.7,28.5,11.5
		c5.4-2.4,10.9-4.4,16.5-6C159.6,69.9,164.3,58.6,169.5,47.5z"/>
	</g>
	<g>
		<path className="st2" d="M154.5,119.5c1-0.1,1.8,0.2,2.5,1c2.2,4.3,4.3,8.7,6.5,13c-34,21.9-43.2,51.5-27.5,89
		c7.1,11.2,16.2,20.2,27.5,27c-2.2,5-4.8,9.7-8,14c-28.9-15.1-43.6-39.1-44-72C112.1,159,126.4,135,154.5,119.5z"/>
	</g>
	<g>
		<path className="st3" d="M192.5,119.5c34.7-0.2,69.3,0,104,0.5c3.2,1.4,6.2,3.1,9,5c8.3,8.3,16.7,16.7,25,25c1.3,0.3,2.7,0.7,4,1
		c37.3,0.3,74.7,0.7,112,1c8.2,2.8,13.7,8.3,16.5,16.5c0.7,50,0.7,100,0,150c-2.8,8.2-8.3,13.7-16.5,16.5c-84.7,0.7-169.3,0.7-254,0
		c-8.2-2.8-13.7-8.3-16.5-16.5c-0.7-60.7-0.7-121.3,0-182C179,128.3,184.5,122.6,192.5,119.5z M199.5,135.5c-4.3,0.8-6.8,3.5-7.5,8
		c-0.7,56-0.7,112,0,168c0.5,4.5,3,7,7.5,7.5c80,0.7,160,0.7,240,0c4.5-0.5,7-3,7.5-7.5c0.7-45.3,0.7-90.7,0-136
		c-0.5-4.5-3-7-7.5-7.5c-37.7-0.3-75.3-0.7-113-1c-3.2-1.4-6.2-3.1-9-5c-8.3-8.3-16.7-16.7-25-25c-1.3-0.3-2.7-0.7-4-1
		C258.8,135.5,229.2,135.3,199.5,135.5z"/>
	</g>
	<g>
		<path className="st4" d="M264.5,193.5c4.9,3.2,9.3,7.2,13,12c-11,11.3-22,22.7-33,34c11,11.3,22,22.7,33,34c-3.7,4.3-7.7,8.3-12,12
		c-15.7-15-31-30.3-46-46C234.5,224.1,249.5,208.8,264.5,193.5z"/>
	</g>
	<g>
		<path className="st4" d="M372.5,193.5c16.3,14.6,31.9,29.9,47,46c-15,15.7-30.3,31-46,46c-4.3-3.7-8.3-7.7-12-12c11-11.3,22-22.7,33-34
		c-11-11.3-22-22.7-33-34C365.2,201.5,368.9,197.5,372.5,193.5z"/>
	</g>
	<g>
		<path className="st5" d="M335.5,203.5c5.7,2,11,4.9,16,8.5c-13.3,23.4-26.5,46.9-39.5,70.5c-0.6,0.5-1.2,0.9-2,1
		c-5.3-1.7-9.8-4.6-13.5-8.5C309.6,251.2,322.6,227.4,335.5,203.5z"/>
	</g>
</svg>
)
const geo_icon = <svg xmlns="http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd" aria-hidden="true"
	strokeWidth={.5} fillRule="evenodd" imageRendering={"optimizeQuality"} textRendering={"geometricPrecision.replace"}
	shapeRendering={"geometricPrecision"}
	clipRule={'evenodd'} viewBox="0 0 500 500" version="1.1" className='w-20 h-20 group-hover:text-main' stroke="black" fill="currentColor"
/* style={{"shape-rendering":"geometricPrecision", "text-rendering":"geometricPrecision.replace",
"image-rendering":"optimizeQuality", "fill-rule":"evenodd" ,"clip-rule":"evenodd"}} */ ><g>
		<path className="st0" d="M241.5,15.5c41.5-3.8,73.7,11.5,96.5,46c15.7,29.1,17.7,59.1,6,90c-15.3,31-30.3,62-45,93
		c13.4-7,26.9-13.8,40.5-20.5c2.7-0.7,5.3-0.7,8,0c32,16,64,32,96,48c1.2,1.2,2.3,2.3,3.5,3.5c16.7,70.4,32.9,140.9,48.5,211.5
		c0.6,5.9-2.1,8.8-8,8.5c-3.6-0.3-6.9-1.5-10-3.5c-33.8-19.8-67.8-39.3-102-58.5c-38.8,20.3-77.5,40.8-116,61.5
		c-2.7,0.7-5.3,0.7-8,0c-38.5-20.7-77.2-41.2-116-61.5c-34.2,19.2-68.2,38.7-102,58.5c-13,7.5-18.8,4-17.5-10.5
		c15.7-69.5,32-138.8,49-208c32.8-16.6,65.6-33.1,98.5-49.5c2.7-0.7,5.3-0.7,8,0c13.7,7.2,27.4,13.7,41,19.5
		c-16.4-32.1-32.2-64.4-47.5-97c-13-41.9-3.8-78.1,27.5-108.5C207,26.3,223.3,18.8,241.5,15.5z M253.5,31.5
		c40.1,2.6,66.2,22.9,78.5,61c4.2,17.8,2.9,35.1-4,52c-24.3,48.9-48.3,97.9-72,147c-24.5-47.7-48.5-95.7-72-144
		c-13.4-32.1-9.4-61.7,12-89C211.6,41.8,230.8,32.8,253.5,31.5z M173.5,244.5c17.4,8.2,34.8,16.7,52,25.5
		c7.7,15.9,15.5,31.7,23.5,47.5c4.3,2.7,8.7,2.7,13,0c7.9-16.2,16.1-32.2,24.5-48c16.7-8.3,33.3-16.7,50-25
		c10.1,58.2,20.1,116.4,30,174.5c-34.2,18-68.4,36.2-102.5,54.5c-0.5-46-0.7-92-0.5-138c-5.3,0-10.7,0-16,0c0.2,46,0,92-0.5,138
		c-33.4-18.2-66.9-36.2-100.5-54c-1.1-2.3-1.3-4.6-0.5-7C155.5,356.5,164.7,300.5,173.5,244.5z M155.5,246.5
		c-8.5,56.9-17.9,113.9-28,171c-29.7,17.8-59.7,35.2-90,52c13.1-61.3,27-122.6,41.5-184C104.6,272.6,130.1,259.6,155.5,246.5z
		 M354.5,246.5c25.9,12.9,51.7,25.9,77.5,39c14.5,61.4,28.4,122.7,41.5,184c-29.9-16.9-59.7-33.9-89.5-51
		C373.8,361.2,364,303.9,354.5,246.5z"/>
	</g>
	<g>
		<path className="st1" d="M281.5,150.5c16.8-11.5,23.6-27.5,20.5-48c-8.1-27.8-26.6-40.3-55.5-37.5c-7.2,1.3-13.7,4.2-19.5,8.5
		c-3.3-4-6.7-8-10-12c-0.6-0.9-0.5-1.8,0.5-2.5c19-12.2,39.3-14.9,61-8c30.7,14.3,44.2,38.5,40.5,72.5
		c-6.6,28.3-24.1,45.5-52.5,51.5c-30.1,3.4-52.9-7.8-68.5-33.5c-7.5-17.3-8.5-34.9-3-53c2.4-5.8,5.6-11.2,9.5-16
		c4.5,3.3,8.8,6.8,13,10.5c-11.8,18.7-12,37.5-0.5,56.5c17.6,20.3,38.5,24.5,62.5,12.5c-2.7,0.8-5.4,0.5-8-1
		c-5.1-3-10.3-5.8-15.5-8.5c-6.2,4.1-12.9,7.5-20,10c-5.1-0.9-7.9-3.9-8.5-9c1.4-7,2.3-14,2.5-21c-4.3-4.3-8.7-8.7-13-13
		c-2.8-5.6-1.6-10.1,3.5-13.5c6.3-1.1,12.6-2.1,19-3c3.2-5.6,6.1-11.4,8.5-17.5c3.4-4.2,7.6-5.4,12.5-3.5c4.5,6.7,8.5,13.7,12,21
		c6.4,0.9,12.7,1.9,19,3c4.9,3.5,6.1,8,3.5,13.5c-4.3,4.3-8.7,8.7-13,13c0.4,7,1.2,14,2.5,21C284.3,146.2,283.3,148.6,281.5,150.5z
		 M255.5,100.5c-2.4,6.4-7,9.5-14,9.5c5.8,4.2,8.1,9.7,7,16.5c5.4-2.8,10.5-2.5,15.5,1c-2-7-0.2-12.9,5.5-17.5
		c-3.5-0.4-6.9-1.4-10-3C258.3,104.7,256.9,102.5,255.5,100.5z"/>
	</g>
</svg>

const mnt_icon = <svg xmlns="http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd" aria-hidden="true"
	strokeWidth={.5} fillRule="evenodd" imageRendering={"optimizeQuality"} textRendering={"geometricPrecision.replace"}
	shapeRendering={"geometricPrecision"}
	clipRule={'evenodd'} viewBox="0 0 500 500" version="1.1" className='w-20 h-20 group-hover:text-main' stroke="black" fill="currentColor"
 /* style={{"shape-rendering":"geometricPrecision", "text-rendering":"geometricPrecision.replace",
 "image-rendering":"optimizeQuality", "fill-rule":"evenodd" ,"clip-rule":"evenodd"}} */ ><g>
		<path className="st0" d="M20.5,18.5c156.7-0.2,313.3,0,470,0.5c12.3,3.2,18,11.2,17,24c1.4,12.1-3.6,19.9-15,23.5c0.2,94,0,188-0.5,282
		c-0.8,0.8-1.7,1.7-2.5,2.5c-21,0.3-42,0.7-63,1c-16.2,23.4-37.5,29.7-64,19c-8.1-4.3-14.5-10.5-19-18.5c-15.7-1.3-31.3-1.3-47,0
		c-9.2,15.4-22.9,23.4-41,24c-18.1-0.6-31.8-8.6-41-24c-15.7-1.3-31.3-1.3-47,0c-13.5,20.2-32.2,27.4-56,21.5
		c-11.7-4-20.7-11.4-27-22c-21-0.3-42-0.7-63-1c-0.8-0.8-1.7-1.7-2.5-2.5c-0.5-94-0.7-188-0.5-282C7.1,62.9,2.1,55.1,3.5,43
		C2.7,30.2,8.3,22,20.5,18.5z M22.5,31.5c155.3-0.2,310.7,0,466,0.5c4.8,1.9,7.1,5.6,7,11c0.1,4.5-1.5,8.2-5,11
		c-156.7,0.7-313.3,0.7-470,0C15,48.2,14.2,41.7,18,34.5C19.4,33.2,20.9,32.2,22.5,31.5z M31.5,67.5c149.3,0,298.7,0,448,0
		c0,90.3,0,180.7,0,271c-16,0-32,0-48,0c2-33.4-13.5-52.4-46.5-57c-23.5,1.5-38.9,13.5-46,36c-1.7,7-1.9,14-0.5,21
		c-12.4,0.3-24.7,0-37-1c3.2-24.7-6.4-42.2-29-52.5c-23.9-7.3-43-0.8-57.5,19.5c-5.9,10.3-7.7,21.3-5.5,33c-12.3,1-24.6,1.3-37,1
		c3.1-26.3-7.5-44.4-32-54.5c-28.7-6.2-48.5,4.3-59.5,31.5c-1.4,7.6-1.9,15.3-1.5,23c-16,0-32,0-48,0
		C31.5,248.2,31.5,157.8,31.5,67.5z M125.5,294.5c21.1,1.9,32.8,13.4,35,34.5c-2.1,20.6-13.4,32.1-34,34.5
		C102.2,360,91,346,93,321.5C98,305.3,108.8,296.3,125.5,294.5z M254.5,294.5c26.2,3.8,37.4,18.8,33.5,45
		c-7.9,18.4-21.7,25.9-41.5,22.5c-19.9-7.9-27.8-22.4-23.5-43.5C229.1,304.6,239.6,296.6,254.5,294.5z M383.5,294.5
		c27.1,3.8,38.2,19.1,33.5,46c-11.3,21.8-28.2,27.6-50.5,17.5c-18-14.9-20.5-32.1-7.5-51.5C365.9,299.7,374.1,295.7,383.5,294.5z"/>
	</g>
	<g>
		<path className="st1" d="M74.5,101.5c6.4-0.4,12.8,0.1,19,1.5c2.7,3.7,2.7,7.3,0,11c-7.3,0.7-14.7,0.7-22,0c-2-2.8-2.5-6-1.5-9.5
		C71.4,103.2,72.9,102.2,74.5,101.5z"/>
	</g>
	<g>
		<path className="st2" d="M112.5,101.5c37.3-0.2,74.7,0,112,0.5c3.7,0.6,5.4,2.7,5,6.5c0.2,2.2-0.5,4-2,5.5c-39.3,0.7-78.7,0.7-118,0
		c-2.8-2.2-3.6-5-2.5-8.5C108.5,103.5,110.3,102.2,112.5,101.5z"/>
	</g>
	<g>
		<path className="st2" d="M361.5,101.5c38.4,2.2,62.6,21.9,72.5,59c4.8,28.6-3.7,52.5-25.5,71.5c-27.3,18.7-55.6,20.4-85,5
		c-31.4-23.1-40.9-53.3-28.5-90.5C308.5,118.7,330.7,103.7,361.5,101.5z M351.5,115.5c-16.5,4-29.7,13-39.5,27
		c-16.1,30.5-11.2,57.2,14.5,80c3.6-4.4,6.6-9.2,9-14.5c-6.1-6.1-10.6-13.3-13.5-21.5c-4.6-27.2,6.3-44.9,32.5-53c1-6,1.3-12,1-18
		C354.2,115.5,352.8,115.5,351.5,115.5z M368.5,115.5c0,6,0,12,0,18c6.6,0.8,12.6,3.1,18,7c4.5-4,8.8-8.2,13-12.5
		C390.4,120.8,380.1,116.6,368.5,115.5z M408.5,137.5c-3.8,4.3-7.8,8.5-12,12.5c3.9,5.6,6.2,11.8,7,18.5c6,0,12,0,18,0
		C420.7,156.6,416.4,146.3,408.5,137.5z M361.5,145.5c-11.6,1.4-20.1,7.4-25.5,18c-5.6,17.7-0.1,30.5,16.5,38.5
		c15.2,4.3,27-0.2,35.5-13.5C395.5,164.1,386.6,149.8,361.5,145.5z M403.5,181.5c-6.4,26.1-23.1,37.6-50,34.5
		c-2.3-1.3-4.7-1.5-7-0.5c-2.5,4.6-5.2,9.1-8,13.5c4.3,2.6,9,4.2,14,5c10.6,1.3,20.9,0.3,31-3c22.3-9.2,35-25.7,38-49.5
		C415.5,181.5,409.5,181.5,403.5,181.5z"/>
	</g>
	<g>
		<path className="st3" d="M72.5,135.5c6.7-0.2,13.3,0,20,0.5c0.9,0.4,1.7,0.9,2.5,1.5c0.7,2.7,0.7,5.3,0,8c-0.9,1.2-2.1,2-3.5,2.5
		c-6,0.7-12,0.7-18,0c-3.8-2.1-5-5.2-3.5-9.5C70.7,137.3,71.5,136.3,72.5,135.5z"/>
	</g>
	<g>
		<path className="st2" d="M109.5,135.5c39-0.2,78,0,117,0.5c2.3,1.3,3.3,3.3,3,6c0.3,3.1-1.1,5.1-4,6c-38,0.7-76,0.7-114,0
		c-3.4-0.7-5.1-2.9-5-6.5C106.6,139,107.6,137,109.5,135.5z"/>
	</g>
	<g>
		<path className="st4" d="M72.5,168.5c6.7-0.2,13.3,0,20,0.5c2.8,2.6,3.7,5.7,2.5,9.5c-0.9,1.2-2.1,2-3.5,2.5c-6,0.7-12,0.7-18,0
		c-3.8-2.1-5-5.2-3.5-9.5C71,170.6,71.9,169.6,72.5,168.5z"/>
	</g>
	<g>
		<path className="st2" d="M109.5,168.5c39-0.2,78,0,117,0.5c2.8,2.6,3.7,5.7,2.5,9.5c-0.9,1.2-2.1,2-3.5,2.5c-38.3,0.7-76.7,0.7-115,0
		C105.6,177.2,105.3,173.1,109.5,168.5z"/>
	</g>
	<g>
		<path className="st5" d="M73.5,201.5c6-0.2,12,0,18,0.5c3.8,2.1,5,5.2,3.5,9.5c-0.5,1.2-1.3,2-2.5,2.5c-6.7,0.7-13.3,0.7-20,0
		C68.3,209.4,68.6,205.2,73.5,201.5z"/>
	</g>
	<g>
		<path className="st2" d="M110.5,201.5c38.3-0.2,76.7,0,115,0.5c3.8,2.1,5,5.2,3.5,9.5c-0.8,0.8-1.7,1.7-2.5,2.5c-39,0.7-78,0.7-117,0
		C105.4,209.4,105.7,205.3,110.5,201.5z"/>
	</g>
	<g>
		<path className="st6" d="M73.5,234.5c6.8-0.4,13.5,0.1,20,1.5c2,2.8,2.5,6,1.5,9.5c-0.8,0.6-1.6,1.1-2.5,1.5c-7.4,0.9-14.8,0.6-22-1
		C68.5,241.2,69.5,237.4,73.5,234.5z"/>
	</g>
	<g>
		<path className="st7" d="M111.5,234.5c38-0.2,76,0,114,0.5c3.2,1,4.5,3.2,4,6.5c0.5,2.7-0.5,4.6-3,5.5c-39,0.7-78,0.7-117,0
		c-3.4-3-3.9-6.5-1.5-10.5C109.3,235.9,110.5,235.2,111.5,234.5z"/>
	</g>
	<g>
		<path className="st7" d="M116.5,380.5c30.2-1.8,55.1,8.9,74.5,32c32.7-36,69.9-41.5,111.5-16.5c6.1,5.1,12,10.6,17.5,16.5
		c34.2-36.9,72.3-41.7,114.5-14.5c27,24.1,42.1,54.3,45.5,90.5c-0.5,1.8-1.7,3-3.5,3.5c-147.3,0.7-294.7,0.7-442,0
		c-2.7-1.3-4.1-3.4-4-6.5c4.3-31.5,17.3-58.6,39-81.5C83.1,391.9,98.7,384,116.5,380.5z M118.5,393.5c25.9-0.8,47.1,8.9,63.5,29
		c13.2,16.8,21.7,35.8,25.5,57c-54.3,0.2-108.7,0-163-0.5c5.2-26.1,17.2-48.4,36-67C91.5,402.3,104.2,396.1,118.5,393.5z
		 M247.5,393.5c26.3-1.3,47.4,8.4,63.5,29c0.7,1,0.7,2,0,3c-10.9,16.4-17.7,34.4-20.5,54c-23.3,0-46.7,0-70,0
		c-3-20.1-10-38.6-21-55.5C211.5,407.5,227.5,397.3,247.5,393.5z M376.5,393.5c27.8-1,50,9.7,66.5,32c11.5,16.2,19.3,34,23.5,53.5
		c-54.3,0.5-108.7,0.7-163,0.5c5.5-31.3,20.9-56.4,46-75.5C358,399,367,395.5,376.5,393.5z"/>
	</g>
</svg>

const survey_icon = (<svg xmlns="http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd" aria-hidden="true"
	strokeWidth={.5} fillRule="evenodd" imageRendering={"optimizeQuality"} textRendering={"geometricPrecision.replace"}
	shapeRendering={"geometricPrecision"}
	clipRule={'evenodd'} viewBox="0 0 500 500" version="1.1"
	className='w-20 h-20 group-hover:text-main' stroke="black" fill="currentColor"
 /* style={{"shape-rendering":"geometricPrecision", "text-rendering":"geometricPrecision.replace",*/ >
	<g><path style={{ "opacity": "0.934" }} d="M 511.5,82.5 C 511.5,85.5 511.5,88.5 511.5,91.5C 509.887,93.2696 507.887,94.4363 505.5,95C 483.503,95.5 461.503,95.6666 439.5,95.5C 439.5,114.833 439.5,134.167 439.5,153.5C 451.545,151.008 461.045,154.675 468,164.5C 469.492,169.411 469.826,174.411 469,179.5C 463.812,191.69 455.979,201.856 445.5,210C 441.469,212.455 437.136,214.121 432.5,215C 413.875,216.419 395.208,216.919 376.5,216.5C 376.334,223.841 376.5,231.174 377,238.5C 417.625,274.943 439.958,320.61 444,375.5C 444.667,383.167 444.667,390.833 444,398.5C 438.501,413.354 428.001,418.521 412.5,414C 404.538,410.37 400.038,404.203 399,395.5C 399.299,353.382 385.965,316.382 359,284.5C 355.953,281.117 352.62,278.117 349,275.5C 346.536,276.161 344.036,276.661 341.5,277C 340.572,277.388 339.905,278.055 339.5,279C 332.528,295.583 325.361,312.083 318,328.5C 312.59,336.462 305.09,341.295 295.5,343C 268.833,343.667 242.167,343.667 215.5,343C 204.476,340.646 196.309,334.479 191,324.5C 184.776,309.051 178.276,293.718 171.5,278.5C 168.081,276.597 164.415,275.763 160.5,276C 128.543,308.835 112.376,348.335 112,394.5C 109.212,410.617 99.712,417.45 83.5,415C 74.6667,412.833 69.1667,407.333 67,398.5C 66.1144,385.088 66.781,371.755 69,358.5C 73.5135,352.253 78.5135,351.92 84,357.5C 82.9358,370.128 82.6024,382.794 83,395.5C 86.5216,400.398 90.5216,400.731 95,396.5C 95.2462,346.225 112.413,302.892 146.5,266.5C 143.506,263.18 141.006,259.513 139,255.5C 118.75,274.981 103.75,297.981 94,324.5C 88.3049,328.719 83.6382,327.719 80,321.5C 79.3333,319.833 79.3333,318.167 80,316.5C 91.2962,285.214 109.63,258.881 135,237.5C 135.5,230.508 135.666,223.508 135.5,216.5C 118.497,216.667 101.497,216.5 84.5,216C 70.7773,214.226 59.944,207.726 52,196.5C 47.8673,190.567 44.534,184.234 42,177.5C 40.4139,168.177 43.5806,161.01 51.5,156C 57.9603,153.799 64.6269,152.965 71.5,153.5C 71.5,134.167 71.5,114.833 71.5,95.5C 49.4975,95.6666 27.4975,95.5 5.5,95C 3.11327,94.4363 1.11327,93.2696 -0.5,91.5C -0.5,88.5 -0.5,85.5 -0.5,82.5C 0.626561,81.8783 1.62656,81.045 2.5,80C 25.4976,79.5 48.4976,79.3334 71.5,79.5C 70.6657,62.8133 78.4991,53.4799 95,51.5C 111.188,53.8546 118.688,63.1879 117.5,79.5C 140.502,79.3334 163.502,79.5 186.5,80C 189.366,81.3929 190.699,83.7262 190.5,87C 190.628,91.8699 188.294,94.5366 183.5,95C 161.503,95.5 139.503,95.6666 117.5,95.5C 117.5,114.833 117.5,134.167 117.5,153.5C 124.532,153.83 131.532,153.497 138.5,152.5C 143.826,141.331 152.493,134.165 164.5,131C 183.638,129.887 202.805,129.387 222,129.5C 238.5,129.667 255,129.833 271.5,130C 279.411,133.555 280.411,138.555 274.5,145C 240.5,145.333 206.5,145.667 172.5,146C 163.171,147.076 156.671,151.91 153,160.5C 152.667,167.167 152.333,173.833 152,180.5C 150.756,186.151 147.256,188.317 141.5,187C 139.998,186.417 138.665,185.584 137.5,184.5C 136.552,179.565 136.219,174.565 136.5,169.5C 111.164,169.333 85.8311,169.5 60.5,170C 58.8198,170.347 57.8198,171.347 57.5,173C 61.2337,182.151 66.9004,189.817 74.5,196C 77.9481,197.927 81.6148,199.261 85.5,200C 106.167,200.333 126.833,200.667 147.5,201C 149.049,202.214 150.215,203.714 151,205.5C 151.333,218.167 151.667,230.833 152,243.5C 155.637,254.121 163.137,259.955 174.5,261C 185.495,261.5 196.495,261.667 207.5,261.5C 212.132,234.537 228.132,220.203 255.5,218.5C 282.868,220.203 298.868,234.537 303.5,261.5C 314.838,261.667 326.172,261.5 337.5,261C 350.594,259.57 358.094,252.404 360,239.5C 360.333,227.833 360.667,216.167 361,204.5C 361.374,203.584 361.874,202.75 362.5,202C 383.411,200.689 404.411,200.022 425.5,200C 440.535,195.968 449.702,186.468 453,171.5C 452.5,171 452,170.5 451.5,170C 426.169,169.5 400.836,169.333 375.5,169.5C 375.888,174.628 375.388,179.628 374,184.5C 369.046,188.677 364.38,188.343 360,183.5C 359.667,176.167 359.333,168.833 359,161.5C 355.441,152.605 348.941,147.439 339.5,146C 331.5,145.667 323.5,145.333 315.5,145C 309.589,138.555 310.589,133.555 318.5,130C 329.279,129.021 339.945,129.688 350.5,132C 361.021,136.022 368.354,143.189 372.5,153.5C 379.5,153.5 386.5,153.5 393.5,153.5C 393.5,134.167 393.5,114.833 393.5,95.5C 371.497,95.6666 349.497,95.5 327.5,95C 322.706,94.5366 320.372,91.8699 320.5,87C 320.301,83.7262 321.634,81.3929 324.5,80C 347.498,79.5 370.498,79.3334 393.5,79.5C 392.312,63.1879 399.812,53.8546 416,51.5C 432.501,53.4799 440.334,62.8133 439.5,79.5C 462.502,79.3334 485.502,79.5 508.5,80C 509.373,81.045 510.373,81.8783 511.5,82.5 Z M 93.5,67.5 C 100.494,68.5092 103.161,72.5092 101.5,79.5C 96.8333,79.5 92.1667,79.5 87.5,79.5C 86.6855,73.8697 88.6855,69.8697 93.5,67.5 Z M 415.5,67.5 C 421.959,68.7907 424.626,72.7907 423.5,79.5C 418.833,79.5 414.167,79.5 409.5,79.5C 408.028,73.5222 410.028,69.5222 415.5,67.5 Z M 87.5,95.5 C 92.1667,95.5 96.8333,95.5 101.5,95.5C 101.5,114.833 101.5,134.167 101.5,153.5C 96.8333,153.5 92.1667,153.5 87.5,153.5C 87.5,134.167 87.5,114.833 87.5,95.5 Z M 409.5,95.5 C 414.167,95.5 418.833,95.5 423.5,95.5C 423.5,114.833 423.5,134.167 423.5,153.5C 418.833,153.5 414.167,153.5 409.5,153.5C 409.5,134.167 409.5,114.833 409.5,95.5 Z M 250.5,234.5 C 276.318,234.836 288.485,247.836 287,273.5C 281.012,291.58 268.512,299.747 249.5,298C 230.669,292.5 222.169,280 224,260.5C 227.424,246.242 236.257,237.575 250.5,234.5 Z M 371.5,256.5 C 375.402,258.893 378.902,261.893 382,265.5C 413.685,302.905 429.019,346.239 428,395.5C 425.369,399.629 421.869,400.462 417.5,398C 416.107,396.829 415.273,395.329 415,393.5C 415.083,344.214 398.25,301.881 364.5,266.5C 367.663,263.683 369.996,260.35 371.5,256.5 Z M 189.5,277.5 C 195.868,277.17 202.202,277.504 208.5,278.5C 218.703,306.775 238.703,318.275 268.5,313C 286.035,307.631 297.369,296.131 302.5,278.5C 309.142,277.336 315.808,277.169 322.5,278C 317.204,290.094 312.038,302.26 307,314.5C 304.083,320.418 299.583,324.585 293.5,327C 268.5,327.667 243.5,327.667 218.5,327C 211.427,324.928 206.594,320.428 204,313.5C 198.877,301.592 194.044,289.592 189.5,277.5 Z" /></g>
	<g><path style={{ "opacity": "0.905" }} d="M 238.5,257.5 C 241.939,257.589 244.772,258.922 247,261.5C 247.789,264.834 248.956,268.001 250.5,271C 253.363,272.399 256.363,273.399 259.5,274C 265.589,281.053 264.255,286.22 255.5,289.5C 238.886,287.394 231.386,278.061 233,261.5C 234.5,259.531 236.333,258.198 238.5,257.5 Z" /></g>
	<g><path style={{ "opacity": "0.915" }} d="M 221.5,393.5 C 226.778,393.575 231.112,395.742 234.5,400C 244.992,406.627 256.158,408.127 268,404.5C 274.379,400.814 280.712,397.147 287,393.5C 297.244,397.748 298.078,403.581 289.5,411C 272.127,423.421 253.46,425.754 233.5,418C 225.548,414.707 219.548,409.374 215.5,402C 216.187,398.16 218.187,395.327 221.5,393.5 Z" /></g>
	<g><path style={{ "opacity": "0.921" }} d="M 195.5,420.5 C 198.187,420.336 200.854,420.503 203.5,421C 233.145,447.497 264.811,450.163 298.5,429C 301.797,426.705 304.797,424.038 307.5,421C 317.333,418.833 321.167,422.667 319,432.5C 294.243,456.316 265.077,464.149 231.5,456C 215.961,451.423 202.794,443.256 192,431.5C 190.882,427.077 192.049,423.41 195.5,420.5 Z" /></g>
</svg>)

const model_icon = (<svg xmlns="http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd" aria-hidden="true"
	strokeWidth={.5} fillRule="evenodd" imageRendering={"optimizeQuality"} textRendering={"geometricPrecision.replace"}
	shapeRendering={"geometricPrecision"}
	clipRule={'evenodd'} viewBox="0 0 500 500" version="1.1"
	className='w-20 h-20 group-hover:text-main ' stroke="black" fill="currentColor"> <g>
		<path className="st0" d="M511.5,41.5c0,61.3,0,122.7,0,184c-4.8,5.3-9.7,5.3-14.5,0c-0.5-42.7-0.7-85.3-0.5-128
		c-74.3,0.2-148.7,0-223-0.5c-2.9-1.4-4.2-3.7-4-7c-0.2-3.3,1.1-5.6,4-7c74.3-0.5,148.7-0.7,223-0.5c0-11,0-22,0-33
		c-160.7,0-321.3,0-482,0c0,11,0,22,0,33c77-0.2,154,0,231,0.5c2.9,1.4,4.2,3.7,4,7c0.2,3.3-1.1,5.6-4,7c-77,0.5-154,0.7-231,0.5
		c0,94,0,188,0,282c32-0.2,64,0,96,0.5c5.3,4.7,5.3,9.3,0,14c-34.7,0.7-69.3,0.7-104,0c-2.9-1.7-5.2-3.9-7-6.5
		c0-115.3,0-230.7,0-346c1.8-2.6,4.1-4.8,7-6.5c166-0.7,332-0.7,498,0C507.4,36.7,509.7,38.9,511.5,41.5z"/>
	</g>
	<g>
		<path className="st1" d="M42.5,58.5c8.1-1.4,11.9,2,11.5,10c-2.4,4.7-6.3,6.2-11.5,4.5C37.2,68.2,37.2,63.3,42.5,58.5z" />
	</g>
	<g>
		<path className="st1" d="M72.5,58.5c8.1-1.4,11.9,2,11.5,10c-2.4,4.7-6.3,6.2-11.5,4.5C67.2,68.2,67.2,63.3,72.5,58.5z" />
	</g>
	<g>
		<path className="st1" d="M102.5,58.5c8.1-1.4,11.9,2,11.5,10c-2.4,4.7-6.3,6.2-11.5,4.5C97.2,68.2,97.2,63.3,102.5,58.5z" />
	</g>
	<g>
		<path className="st2" d="M249.5,109.5c19.7-0.8,29.2,8.5,28.5,28c15.2,9.9,30.5,19.6,46,29c10.5-6.9,20.6-6.4,30.5,1.5
		c7.4,10.2,7.9,20.7,1.5,31.5c-2.5,3.2-5.7,5.2-9.5,6c0,22,0,44,0,66c7,2.1,11.5,6.8,13.5,14c2.8,15.6-3.4,25.4-18.5,29.5
		c-6,0.8-11.7-0.3-17-3.5c-15.7,9.8-31.3,19.7-47,29.5c0.6,18.4-8.4,27.1-27,26c-9-1.6-14.8-6.8-17.5-15.5
		c-0.2-3.9-0.7-7.8-1.5-11.5c-14.7-9.3-29.3-18.7-44-28c-3.3,0.8-6.6,1.8-10,3c-12.9,1.7-21.7-3.5-26.5-15.5c-3-13.6,1.6-23.2,14-29
		c0.7-21.3,0.7-42.7,0-64c-12.4-5.8-17.1-15.5-14-29c6-13.4,16.1-18.3,30.5-14.5c2.1,0.8,3.9,2,5.5,3.5c15-9.7,30-19.3,45-29
		C230.8,123.6,236.6,114.2,249.5,109.5z M252.5,125.5c-3.6,2.4-4.7,5.7-3.5,10c5.8,5.9,10.3,4.9,13.5-3
		C261.2,127.2,257.9,124.9,252.5,125.5z M240.5,151.5c-14.2,9.3-28.5,18.5-43,27.5c-1.1,0.7-1.7,1.7-2,3c1.3,2,1.3,4,0,6
		c0.3,1.3,0.9,2.3,2,3c14.3,8.6,28.3,17.6,42,27c5-2.3,10.3-3.8,16-4.5c5.1,0.5,9.8,2.2,14,5c15.3-9.5,30.4-19.2,45.5-29
		c-0.5-2.5-0.3-5,0.5-7.5c-0.3-1.3-0.9-2.3-2-3c-14.3-9-28.7-18-43-27c-4.8,1.6-9.8,2.8-15,3.5C250.2,155.3,245.2,153.9,240.5,151.5
		z M171.5,177.5c-4.4,1.9-5.9,5.3-4.5,10c3.5,4.9,7.5,5.2,12,1C181.1,182,178.6,178.3,171.5,177.5z M336.5,177.5
		c-5.7,3.2-6.7,7.4-3,12.5c4.4,2.5,7.9,1.6,10.5-2.5C345.2,181.5,342.7,178.2,336.5,177.5z M185.5,203.5c15.9,9,31.4,18.7,46.5,29
		c-1.1,12.1,3.7,20.8,14.5,26c1.2,21.3,1.3,42.7,0.5,64c-2.2,1.2-4.4,2.5-6.5,4c-14.7-9.3-29.3-18.7-44-28c0.9-9.5-2.1-17.7-9-24.5
		c-1.7-1.6-3.7-2.4-6-2.5c0-22,0-44,0-66C183.4,205.8,184.7,205.1,185.5,203.5z M323.5,203.5c2.1,1.1,4.2,2.1,6.5,3
		c0.7,21.3,0.7,42.7,0,64c-11.7,5.7-16.9,15-15.5,28c-15,9.1-29.8,18.5-44.5,28c-1.8-1.1-3.6-2.1-5.5-3c-1.2-21.7-1.3-43.3-0.5-65
		c10.5-5.9,15.3-14.7,14.5-26.5C293.6,222.5,308.6,213,323.5,203.5z M253.5,229.5c9,2.1,10.6,6.6,5,13.5c-7.8,1.5-11-1.7-9.5-9.5
		C250.4,231.9,251.9,230.6,253.5,229.5z M170.5,285.5c8.3,0,11,3.6,8,11c-4.2,4.1-8,3.8-11.5-1C165.8,291.2,166.9,287.9,170.5,285.5
		z M335.5,285.5c7.3-0.5,10.1,2.9,8.5,10c-6.1,5.6-10.6,4.4-13.5-3.5C331.3,289.1,332.9,286.9,335.5,285.5z M252.5,337.5
		c8.9,0.2,11.4,4.2,7.5,12c-4.4,3.1-8,2.4-11-2C247.8,343.2,248.9,339.9,252.5,337.5z"/>
	</g>
	<g>
		<path className="st3" d="M42.5,135.5c10.7-0.2,21.3,0,32,0.5c5.3,4.7,5.3,9.3,0,14c-10.7,0.7-21.3,0.7-32,0
		C37.2,145.2,37.2,140.3,42.5,135.5z"/>
	</g>
	<g>
		<path className="st3" d="M436.5,135.5c10.7-0.2,21.3,0,32,0.5c5.3,4.7,5.3,9.3,0,14c-10.7,0.7-21.3,0.7-32,0
		C431.2,145.2,431.2,140.3,436.5,135.5z"/>
	</g>
	<g>
		<path className="st4" d="M40.5,163.5c17.3-0.2,34.7,0,52,0.5c5.3,4.7,5.3,9.3,0,14c-17.3,0.7-34.7,0.7-52,0
		C36.5,173.2,36.5,168.3,40.5,163.5z"/>
	</g>
	<g>
		<path className="st4" d="M418.5,163.5c17.3-0.2,34.7,0,52,0.5c4,4.7,4,9.3,0,14c-17.3,0.7-34.7,0.7-52,0
		C413.2,173.2,413.2,168.3,418.5,163.5z"/>
	</g>
	<g>
		<path className="st5" d="M40.5,191.5c21.3-0.2,42.7,0,64,0.5c8.3,6.1,15,13.6,20,22.5c-2,7-6.3,9.1-13,6.5c-4.7-4.7-9.3-9.3-14-14
		c-19-0.3-38-0.7-57-1C36.5,201.2,36.5,196.3,40.5,191.5z"/>
	</g>
	<g>
		<path className="st5" d="M406.5,191.5c21.3-0.2,42.7,0,64,0.5c4,4.7,4,9.3,0,14c-19,0.3-38,0.7-57,1c-4.7,4.7-9.3,9.3-14,14
		c-6.7,2.6-11,0.5-13-6.5c0.7-2,1.6-4,2.5-6C394.7,202.6,400.6,196.9,406.5,191.5z"/>
	</g>
	<g>
		<path className="st6" d="M511.5,253.5c0,44.7,0,89.3,0,134c-1.8,2.6-4.1,4.8-7,6.5c-68.3,0.5-136.7,0.7-205,0.5c0,9.7,0,19.3,0,29
		c26.4-0.2,41.4,12.8,45,39c0.4,6.4-2.2,10.9-8,13.5c-27,0.7-54,0.7-81,0c-5.3-4.7-5.3-9.3,0-14c24.3-0.2,48.7-0.7,73-1.5
		c-3.3-13.1-11.6-20.3-25-21.5c-34.4-1-68.7-0.6-103,1c-9.7,3.5-15.7,10.4-18,20.5c15.3,0.8,30.7,1.3,46,1.5c1.8,0.5,3,1.7,3.5,3.5
		c1.4,4.5,0.2,8-3.5,10.5c-9,0.2-18,0.3-27,0.5c-35,5.5-43.9-7.2-26.5-38c9.5-11.5,21.6-16.5,36.5-15c0-9.7,0-19.3,0-29
		c-24,0.2-48,0-72-0.5c-5.3-4.7-5.3-9.3,0-14c119-0.5,238-0.7,357-0.5c-0.2-42,0-84,0.5-126C501.8,248.2,506.6,248.2,511.5,253.5z
		 M227.5,394.5c18.7,0,37.3,0,56,0c0,9.7,0,19.3,0,29c-18.7,0-37.3,0-56,0C227.5,413.8,227.5,404.2,227.5,394.5z"/>
	</g>
	<g>
		<path className="st7" d="M113.5,254.5c9.7,0.5,12.6,5.1,8.5,14c-5.5,5.9-11.4,11.4-17.5,16.5c-21.3,0.7-42.7,0.7-64,0
		c-4-4.7-4-9.3,0-14c19.3-1.3,38.6-2,58-2C103.4,263.9,108.4,259.1,113.5,254.5z"/>
	</g>
	<g>
		<path className="st7" d="M391.5,254.5c2.8-0.3,5.5,0.2,8,1.5c4.3,4.3,8.7,8.7,13,13c19.4,0,38.7,0.7,58,2c4,4.7,4,9.3,0,14
		c-21.3,0.7-42.7,0.7-64,0c-8.3-6.1-15-13.6-20-22.5C387.2,259.1,388.8,256.5,391.5,254.5z"/>
	</g>
	<g>
		<path className="st8" d="M44.5,297.5c14.7-0.2,29.3,0,44,0.5c8.8,3,10.1,8,4,15c-17.3,0.7-34.7,0.7-52,0c-2.9-3.3-3.8-7.1-2.5-11.5
		C39.8,299.4,42,298,44.5,297.5z"/>
	</g>
	<g>
		<path className="st8" d="M422.5,297.5c16.1-0.4,32.1,0.1,48,1.5c4,4.7,4,9.3,0,14c-17.3,0.7-34.7,0.7-52,0
		C412.4,305.8,413.8,300.7,422.5,297.5z"/>
	</g>
	<g>
		<path className="st9" d="M45.5,325.5c9.7-0.4,19.4,0.1,29,1.5c5.3,4.6,5.3,9.3,0,14c-10.7,0.7-21.3,0.7-32,0
		C36.5,334.4,37.5,329.2,45.5,325.5z"/>
	</g>
	<g>
		<path className="st9" d="M439.5,325.5c9.7-0.4,19.4,0.1,29,1.5c5.3,4.6,5.3,9.3,0,14c-10.7,0.7-21.3,0.7-32,0
		C430.5,334.4,431.5,329.2,439.5,325.5z"/>
	</g>
</svg>
)
const monitoring_icon = <svg xmlns="http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd" aria-hidden="true"
	strokeWidth={.5} fillRule="evenodd" imageRendering={"optimizeQuality"} textRendering={"geometricPrecision.replace"}
	shapeRendering={"geometricPrecision"}
	clipRule={'evenodd'} viewBox="0 0 500 500" version="1.1"
	className='w-20 h-20 group-hover:text-main' stroke="black" fill="currentColor"><g>
		<path className="st0" d="M69.5,21.5c101.7-0.2,203.3,0,305,0.5c4.1,1.8,7.3,4.6,9.5,8.5c1.3,68.6,2,137.3,2,206
	c36.8,31.8,47.2,70.8,31,117c-2,4.2-4.2,8.4-6.5,12.5c6.3,4.6,12.3,9.6,18,15c6.4-1.4,12.4-0.4,18,3c17,15.4,34.4,30.4,52,45
	c6,7.8,6.5,16,1.5,24.5c-6.5,7.2-13,14.3-19.5,21.5c-5.1,2.4-10.4,3.1-16,2c-19.8-16.1-39.3-32.6-58.5-49.5c-2.9-4.9-4.2-10.2-4-16
	c-5.3-4.7-10.7-9.3-16-14c-0.3,10-0.7,20-1,30c-1.4,6.4-5.2,10.6-11.5,12.5c-13,0.5-26,0.7-39,0.5c0.2,12.3,0,24.7-0.5,37
	c-1.7,5.4-5.2,9.2-10.5,11.5c-101.7,0.7-203.3,0.7-305,0c-5.1-1.4-8.6-4.6-10.5-9.5c-0.7-132.7-0.7-265.3,0-398
	c2.2-5.2,6.1-8.7,11.5-10.5c12.7-0.5,25.3-0.7,38-0.5c-0.2-11.7,0-23.3,0.5-35C59.2,28.5,63,23.8,69.5,21.5z M74.5,38.5
	c98,0,196,0,294,0c0.2,62.7,0,125.3-0.5,188c-10.5-5.5-21.6-8.5-33.5-9c0.5-30.7,0-61.4-1.5-92c-16.8-17.8-34-35.3-51.5-52.5
	c-1.6-0.9-3.3-1.5-5-2c-67.3-0.5-134.7-0.7-202-0.5C74.5,59.8,74.5,49.2,74.5,38.5z M23.5,87.5c81.3,0,162.7,0,244,0
	c-0.2,14,0,28,0.5,42c1.2,3.8,3.7,6.3,7.5,7.5c14,0.5,28,0.7,42,0.5c0,26.7,0,53.3,0,80c-31.7,3.3-56.3,18.2-74,44.5
	c-29.1,0-58.1,0.7-87,2c-5.6,5.5-5.2,10.5,1,15c25.7,0.2,51.3,0.7,77,1.5c-2.9,7.1-4.6,14.4-5,22c-24.3-0.2-48.7,0-73,0.5
	c-5.3,5-5.3,10,0,15c24,0.5,48,0.7,72,0.5c0.5,18.6,5.9,35.6,16,51c-29,0.8-58,1.3-87,1.5c-5,3-6.2,7.2-3.5,12.5
	c1.2,1.5,2.7,2.7,4.5,3.5c34,0.3,68,0.7,102,1c16.1,14.7,35.1,22.9,57,24.5c0,20,0,40,0,60c-98,0-196,0-294,0
	C23.5,344.2,23.5,215.8,23.5,87.5z M284.5,100.5c6.8,6.3,13.5,12.8,20,19.5c-6.7,0.5-13.3,0.7-20,0.5
	C284.5,113.8,284.5,107.2,284.5,100.5z M324.5,233.5c42.7,2.2,69.9,23.9,81.5,65c5.7,39.8-8.8,69.7-43.5,89.5
	c-36.4,15.4-68.5,9.2-96.5-18.5c-21.4-26.2-26.1-55.2-14-87C266.8,252.3,291,236,324.5,233.5z M399.5,380.5c1.4,0.2,2.8,0.7,4,1.5
	c4.3,3.7,8.7,7.3,13,11c-1.3,1.4-2.5,2.9-3.5,4.5c-5.8-4.1-11.3-8.6-16.5-13.5C397.7,383,398.7,381.8,399.5,380.5z M435.5,397.5
	c17.1,14.6,34.1,29.5,51,44.5c-5.5,6-10.9,12.2-16,18.5c-17.1-14.6-34.1-29.5-51-44.5C425,410,430.4,403.8,435.5,397.5z
	 M366.5,404.5c2,5.9,2.6,12.2,2,19c-11.3,0-22.7,0-34,0c-0.3-3.6,0-7.1,1-10.5C346.5,412.2,356.8,409.3,366.5,404.5z"/>
	</g>
	<g>
		<path className="st1" d="M77.5,136.5c28-3.1,46.5,8.6,55.5,35c4.3,21.4-2.2,38.5-19.5,51.5c-23.6,12.5-44.8,9.4-63.5-9.5
	c-15.9-24.6-13.4-47.1,7.5-67.5C63.6,141.4,70.3,138.3,77.5,136.5z M86.5,152.5c-13.8,1.7-23.3,9-28.5,22
	c-3.5,19.2,4,32.1,22.5,38.5c21.3,1.5,33.7-8.3,37-29.5C115.5,164.8,105.2,154.5,86.5,152.5z"/>
	</g>
	<g>
		<path className="st2" d="M157.5,155.5c46.7-0.2,93.3,0,140,0.5c4.3,3.8,5.1,8.3,2.5,13.5c-1.4,1-2.9,1.8-4.5,2.5
	c-45.7,0.7-91.3,0.7-137,0C150.9,166.8,150.6,161.3,157.5,155.5z"/>
	</g>
	<g>
		<path className="st2" d="M157.5,194.5c46.3-0.2,92.7,0,139,0.5c5.1,3.4,6.3,7.9,3.5,13.5c-0.9,1.2-2.1,2-3.5,2.5c-46,0.7-92,0.7-138,0
	C150.8,205.9,150.5,200.4,157.5,194.5z"/>
	</g>
	<g>
		<path className="st3" d="M315.5,242.5c43.2-2.6,70.7,16.7,82.5,58c5.1,33.9-6.7,60.1-35.5,78.5c-28.2,13.6-55.2,11.6-81-6
	c-23.9-20.7-32.4-46.5-25.5-77.5C265.7,266.3,285.5,248.6,315.5,242.5z M317.5,259.5c-14.9,3.2-27.1,10.9-36.5,23
	c-16.4,27.6-13.2,52.8,9.5,75.5c22,16.3,44.7,17.3,68,3c22.4-17.8,28.9-40.3,19.5-67.5C365.5,268.8,345.4,257.5,317.5,259.5z"/>
	</g>
	<g>
		<path className="st3" d="M80.5,243.5c32.2-0.6,50.2,15.1,54,47c-2.6,29.1-18.4,45.1-47.5,48c-23.5-1.5-38.9-13.5-46-36
	C36.8,270.9,49.9,251.3,80.5,243.5z M81.5,260.5c-11.5,3.3-19.3,10.6-23.5,22c-3.2,22.5,6.4,35.5,29,39
	c18.2-2.2,28.3-12.3,30.5-30.5C114.5,270.2,102.5,260,81.5,260.5z"/>
	</g>
	<g>
		<path className="st4" d="M77.5,351.5c27.6-2.6,46.1,9.1,55.5,35c4.3,21.4-2.2,38.5-19.5,51.5c-23.6,12.5-44.8,9.4-63.5-9.5
	c-15.9-24.6-13.4-47.1,7.5-67.5C63.6,356.4,70.3,353.3,77.5,351.5z M86.5,367.5c-13.8,1.7-23.3,9-28.5,22
	c-3.5,19.2,4,32.1,22.5,38.5c21.3,1.5,33.7-8.3,37-29.5C115.5,379.8,105.2,369.5,86.5,367.5z"/>
	</g>
	<g>
		<path className="st2" d="M157.5,409.5c46.3-0.2,92.7,0,139,0.5c5.1,3.4,6.3,7.9,3.5,13.5c-0.9,1.2-2.1,2-3.5,2.5c-46,0.7-92,0.7-138,0
	C150.8,420.9,150.5,415.4,157.5,409.5z"/>
	</g>
</svg>
const feasibility_icon = <svg xmlns="http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd" aria-hidden="true"
	strokeWidth={.5} fillRule="evenodd" imageRendering={"optimizeQuality"}
	textRendering={"geometricPrecision.replace"}
	shapeRendering={"geometricPrecision"}
	clipRule={'evenodd'} viewBox="0 0 500 500" version="1.1"
	className='w-20 h-20 group-hover:text-main ' fill="currentColor" >
	<g>
		<path class="st0" d="M46.5-0.5c101,0,202,0,303,0c40.6,39.1,80.7,78.7,120.5,119c1.6,2.2,2.9,4.5,4,7c0.7,125,0.7,250,0,375
		c-1.6,5.1-4.8,8.8-9.5,11c-139.3,0-278.7,0-418,0c-4.7-2.2-7.9-5.9-9.5-11c-0.7-163.3-0.7-326.7,0-490C38.6,5.4,41.8,1.7,46.5-0.5z
		 M67.5,29.5c87,0,174,0,261,0c-0.2,35.3,0,70.7,0.5,106c1.5,4.2,4.3,7,8.5,8.5c35.3,0.5,70.7,0.7,106,0.5c0,112.3,0,224.7,0,337
		c-125.3,0-250.7,0-376,0C67.5,330.8,67.5,180.2,67.5,29.5z M358.5,52.5c20.8,20.3,41.5,40.8,62,61.5c-20.7,0.5-41.3,0.7-62,0.5
		C358.5,93.8,358.5,73.2,358.5,52.5z"/>
	</g>
	<g>
		<path class="st1" d="M106.5,59.5c61-0.2,122,0,183,0.5c8.4,4.3,11.2,11.2,8.5,20.5c-1.5,4.2-4.3,7-8.5,8.5c-61,0.7-122,0.7-183,0
		c-9-5.2-11.5-12.7-7.5-22.5C101,63.6,103.5,61.3,106.5,59.5z"/>
	</g>
	<g>
		<path class="st1" d="M106.5,119.5c61-0.2,122,0,183,0.5c8.4,4.3,11.2,11.2,8.5,20.5c-1.5,4.2-4.3,7-8.5,8.5c-61,0.7-122,0.7-183,0
		c-9-5.2-11.5-12.7-7.5-22.5C101,123.6,103.5,121.3,106.5,119.5z"/>
	</g>
	<g>
		<path class="st2" d="M106.5,179.5c99.3-0.2,198.7,0,298,0.5c9,5.2,11.5,12.7,7.5,22.5c-1.8,3-4.3,5.1-7.5,6.5
		c-99.3,0.7-198.7,0.7-298,0c-9-5.2-11.5-12.7-7.5-22.5C101,183.6,103.5,181.3,106.5,179.5z"/>
	</g>
	<g>
		<path class="st3" d="M240.5,243.5c50.5-4,87.4,16.3,110.5,61c18.6,50.5,7.4,93-33.5,127.5c-31.1,21-64.4,25.4-100,13
		c-50.4-23.5-71.9-63-64.5-118.5c8.5-36.5,30-62,64.5-76.5C225.2,247.3,232.8,245.2,240.5,243.5z M254.5,273.5
		c-15.3,0.8-29.3,5.7-42,14.5c-31.6,26.8-38.5,58.9-20.5,96.5c23.1,33.5,54,43.7,92.5,30.5c32.6-16.4,47.1-42.9,43.5-79.5
		C318.6,297,294.1,276.3,254.5,273.5z"/>
	</g>
	<g>
		<path class="st4" d="M278.5,314.5c17.7-0.8,23.9,7.2,18.5,24c-13.2,13.2-26.3,26.3-39.5,39.5c-6.3,3.3-12.7,3.3-19,0
		c-8.2-8.2-16.3-16.3-24.5-24.5c-5.4-16.9,0.8-24.8,18.5-23.5c5.8,3.8,10.9,8.3,15.5,13.5C257.8,333.2,267.9,323.6,278.5,314.5z"/>
	</g></svg>


export const header_navs = [
	{
		icon: <i className="fa-solid fa-house fa-lg" style={{ "color": "#dadbdc" }}></i>,
		name: 'home',
		url: '/',
	},
	{
		icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
			className="w-6 h-6 mx-auto">
			<path fillRule="evenodd" d="M1.5 7.125c0-1.036.84-1.875 1.875-1.875h6c1.036 0 1.875.84 1.875 1.875v3.75c0 1.036-.84 1.875-1.875 1.875h-6A1.875 1.875 0 011.5 10.875v-3.75zm12 1.5c0-1.036.84-1.875 1.875-1.875h5.25c1.035 0 1.875.84 1.875 1.875v8.25c0 1.035-.84 1.875-1.875 1.875h-5.25a1.875 1.875 0 01-1.875-1.875v-8.25zM3 16.125c0-1.036.84-1.875 1.875-1.875h5.25c1.036 0 1.875.84 1.875 1.875v2.25c0 1.035-.84 1.875-1.875 1.875h-5.25A1.875 1.875 0 013 18.375v-2.25z" clipRule="evenodd" />
		</svg>,
		name: 'about us',
		url: '/about',
	},
	{
		icon: <i className="fa-solid fa-briefcase  fa-lg" style={{ "color": "#dadbdc" }}></i>,

		name: 'projects',
		url: '/project',
	},
	{
		icon: <i className="fa-solid fa-screwdriver-wrench fa-lg" style={{ "color": "#dadbdc" }}></i>,
		name: 'services',
		url: '/services',

	},{
		icon: <i className="fa-solid fa-screwdriver-wrench fa-lg" style={{ "color": "#dadbdc" }}></i>,
		name: 'eBrochure',
		url: 'https://ebrochure.tiller.com.bd',

	},

	/* 	{
			icon: <i className="fa-solid fa-user-tie  fa-lg" style={{ "color": "#dadbdc" }}></i>,
	
			name: 'People',
			url: '/people',
		}, */
	{
		icon: <i className="fa-solid fa-location-dot fa-lg" style={{ "color": "#dadbdc" }}></i>,
		name: 'Contact',
		url: '/contact',
		handler: (navigate) => {

		}
	}
]

export const drawer_navs = [
	{ name: 'home', url: '/' },
	{ name: 'projects', url: '/projects' }
	, { name: 'services', url: '/services' },
	{ name: 'about us', url: '/about' },
	{name: 'e-brochure',
		url: 'https://ebrochure.tiller.com.bd'},
	/* { name: 'people', url: '/people' } */, { name: 'contact us', url: '/contact' }, /* { name: 'carreer', url: '/' }, */
]

export const footer_navs = [
	{
		name: 'services',
		url: '/services',
	},
	{
		name: 'projects',
		url: '/projects',
	},
	/* {
		name: 'people',
		url: '/people',
	}, */
	{
		name: 'about',
		url: '/about',
	},
	 {
		name: 'career ',
		url: '/career',
	}
	, 
	{
		name: 'contact',
		url: '/contact',
	}
	
]

export const social_navs = [
	{
		name: "facebook",
		icon: <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" className="w-8 h-8 " stroke="currentColor" fill="currentColor"
			viewBox="0 0 24 24" id="facebook">
			<path d="M15.12 5.32H17V2.14A26.11 26.11 0 0 0 14.26 2C11.54 2 9.68 3.66 9.68 6.7V9.32H6.61v3.56H9.68V22h3.68V12.88h3.06l.46-3.56H13.36V7.05C13.36 
      6 13.64 5.32 15.12 5.32Z">

			</path>
		</svg>,
		url: 'https://www.facebook.com/tiller.ltd/'
	},

	{
		name: "linkedin",
		icon: <svg className="w-8 h-8 " xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16 " id="linkedin">
			<path d="M0 5h3.578v11H0zM13.324 5.129c-.038-.012-.074-.025-.114-.036a2.32 2.32 0 0 0-.145-.028A3.207
       3.207 0 0 0 12.423 5c-2.086 0-3.409 1.517-3.845 2.103V5H5v11h3.578v-6s2.704-3.766 3.845-1v7H16V8.577a3.568 3.568 0 0 0-2.676-3.448z">
			</path><circle cx="1.75" cy="1.75" r="1.75"></circle></svg>,
		url: 'https://www.linkedin.com/company/tillerbd/mycompany/'
	},
]

export const services_list = [
	{ name: "Urban Planning and Design", order: 1, icon: pnd_icon, url: "/" },
	{ name: "GIS Application Development", order: 6, icon: geo_icon, url: "/" },
	{ name: "Capacity Building", order: 8, icon: mnt_icon, url: "/" },
	{ name: "Software and Application Development", order: 2, icon: soft_icon, url: "/" },
	{ name: "(UAV/Drone/Aerial) Survey and Mapping", order: 7, icon: survey_icon, url: "/" },
	{ name: "Modeling and Simulation", order: 3, icon: model_icon, url: "/" },
	{ name: "Feasibility and Detailed Design", order: 4, icon: feasibility_icon, url: "/" },
	{ name: "Monitoring and Evaluation", order: 5, icon: monitoring_icon, url: "/" },
]

export const districtsOfBangladesh = [
	"Bagerhat",
	"Bandarban",
	"Barguna",
	"Barishal",
	"Bhola",
	"Bogra",
	"Brahmanbaria",
	"Chandpur",
	"Chapai Nawabganj",
	"Chattogram",
	"Chuadanga",
	"Comilla",
	"Cox's Bazar",
	"Dhaka",
	"Dinajpur",
	"Faridpur",
	"Feni",
	"Gaibandha",
	"Gazipur",
	"Gopalganj",
	"Habiganj",
	"Jamalpur",
	"Jashore",
	"Jhalokati",
	"Jhenaidah",
	"Joypurhat",
	"Khagrachari",
	"Khulna",
	"Kishoreganj",
	"Kurigram",
	"Kushtia",
	"Lakshmipur",
	"Lalmonirhat",
	"Madaripur",
	"Magura",
	"Manikganj",
	"Meherpur",
	"Moulvibazar",
	"Munshiganj",
	"Mymensingh",
	"Naogaon",
	"Narail",
	"Narayanganj",
	"Narsingdi",
	"Natore",
	"Nawabganj",
	"Netrokona",
	"Nilphamari",
	"Noakhali",
	"Pabna",
	"Panchagarh",
	"Pirojpur",
	"Rajbari",
	"Rajshahi",
	"Rangamati",
	"Rangpur",
	"Satkhira",
	"Shariatpur",
	"Sherpur",
	"Sirajganj",
	"Sunamganj",
	"Sylhet",
	"Tangail",
	"Thakurgaon",
];

export const job_posts_collection = [
	{
		"order": 1,
		"title": "Junior GIS Analyst",
		"status": "published",
		"duration":'full-time',
		"publish_date": "2024-02-29",
		"expire_date": "",
		"job_post_id": "X4Y8W9Z2",
		"job_responsibilities": [
			"Prepare field survey plan & GIS Database",
			"Coordinate the survey team & work closely with Technical Coordinator",
			"All survey-related documentation",
			"QC management (survey work & GIS Database)",
			"Prepare map-update plan & coordinate GIS team regularly",
			"Prepare report in timely manner (weekly/monthly survey progress report, QA report, etc.)",
			"Perform related duties as assigned",
			"Field visit (anywhere in Bangladesh)"
		],
		"academic_qualification": "At least bachelor’s in Geography, GIS, Urban & Regional/Rural Planning or relevant subject from any reputed university.",
		"experience": "1-2 years of relevant experience. Freshers are encouraged to apply.",
		"skills": [
			"Analytical Ability",
			"Clear Knowledge on Spatial and Non-spatial Database",
			"Skills in GIS Application, Database Management Application, Statistical Software",
			"Excellent Communication Skills (verbal and written) in English and Bengali",
			"Report Writing Skill both in English and Bengali",
			"Ability to Work under Pressure"
		]
	},
	{
		"order": 2,
		"title": "Director, Infrastructure Engineering (Civil)",
		"status": "published",
		"duration":'full-time',
		"publish_date": "2024-02-29",
		"expire_date": "",
		"job_post_id": "R6E3K9A7",
		"job_context": "The Director of Infrastructure Engineering is a key leadership role responsible for overseeing the acquisition of new business, leading projects, and providing strategic direction to a dynamic team.",
		"job_responsibilities": [
			"Strategic Decision-Making",
			"Business Acquisition",
			"Partnership Establishment",
			"Project Leadership",
			"Team Leadership",
			"Financial Management",
			"Service Excellence"
		],
		"qualification": "Bachelor's or advanced degree in Civil Engineering, Structural Engineering, or Environmental Engineering.",
		"experience": "20 (+) proven experience in infrastructure engineering and project management.",
		"skills": [
			"Strategic thinking and decision-making abilities",
			"Strong leadership and team management skills",
			"Excellent financial management and budgeting skills",
			"Effective communication and interpersonal skills",
			"Business development experience in the relevant engineering sector is highly desirable"
		]
	},
	{
		"order": 3,
		"title": "Manager, Business Development – Software Development Team",
		"status": "published",
		"duration":'full-time',
		"publish_date": "2024-02-29",
		"expire_date": "",
		"job_post_id": "T2B5H1X8",
		"job_context": "The Manager of Business Development for the Software Development Team will be a key player in driving the growth and success of our business.",
		"job_responsibilities": [
			"Develop and implement a comprehensive new business strategy for the software development team",
			"Conduct in-depth business analysis to understand market trends, competitor landscapes, and customer needs",
			"Evaluate the feasibility and viability of potential new business opportunities",
			"Provide data-driven insights and recommendations to inform strategic decision-making",
			"Lead feasibility research initiatives for new software development projects",
			"Actively pursue and acquire new business opportunities for the software development team"
		],
		"education": "Bachelor’s degree in business or marketing or computer science, or a related field.",
		"experience": "10 years of proven experience in business development, with a focus on software development or IT services.",
		"skills": [
			"Strategic thinking and decision-making abilities",
			"Strong leadership and team management skills",
			"Excellent financial management and budgeting skills",
			"Effective communication and interpersonal skills"
		]
	},
	{
		"order": 4,
		"title": "Consultant, Associate Researcher",
		"status": "published",
		"duration":'full-time',
		"publish_date": "2024-02-29",
		"expire_date": "",
		"job_post_id": "Q7D2F4N5",
		"education": "Master’s Degree in the field of Economics, Sociology, Labor Studies, Business Administration, Statistics.",
		"experience": "At least 7 years of experience in management of technical assistance/ consultancy contracts. Minimum 4 years of experience in research related work or consultancy.",
		"skills": [
			"Strategic thinking and decision-making abilities",
			"Strong leadership and team management skills",
			"Excellent financial management and budgeting skills",
			"Effective communication and interpersonal skills"
		]
	},
	{
		"order": 5,
		"title": "Consultant, Lead Researcher",
		"status": "published",
		"duration":'full-time',
		"publish_date": "2024-02-29",
		"expire_date": "",
		"job_post_id": "Y1Z9A3W8",
		"education": "Master’s Degree in the field of Economics, Sociology, Labor Studies, Business Administration, Statistics. PhD in the relevant field will be an advantage.",
		"experience": "At least 10 years of experience in the research field. Should have proficiency in research methodologies, both quantitative and qualitative including survey design, data collection, statistical analysis and experience in conducting interviews, focus group discussion and stakeholder consultations.",
		"skills": [
			"Strategic thinking and decision-making abilities",
			"Strong leadership and team management skills",
			"Excellent financial management and budgeting skills",
			"Effective communication and interpersonal skills"
		]
	},
	{
		"order": 6,
		"title": "Associate Urban Planner",
		"status": "published",
		"duration":'full-time',
		"publish_date": "2024-02-29",
		"expire_date": "",
		"job_post_id": "X3E5B1K7",
		"job_responsibilities": [
			"Prepare reports, concept notes, proposals, and other written materials related to urban planning",
			"Prepare and deliver presentations to clients and stakeholders and participate in public meetings",
			"Design GIS database, base maps, and other visualizations to support data analysis and decision-making"
		],
		"qualification_and_experience": "Bachelor/Master of Urban and Regional Planning/Rural Planning. 3-5 years’ work experience in a related field.",
		"skills_and_knowledge": [
			"Good interpersonal and intercultural skills, the ability to communicate clearly and effectively and build relationships at all levels",
			"High level of attention to detail in all aspects of work responsibilities",
			"Training, report writing and presentation skills",
			"Ability to prioritize multiple tasks and meet deadlines",
			"Strong project management and proven coordination skills",
			"Strong interpersonal skills and good understanding of the global organization"
		]
	},
	{
		"order": 7,
		"title": "Software Engineer",
		"status": "published",
		"duration":'full-time',
		"publish_date": "2024-02-29",
		"expire_date": "",
		"job_post_id": "M6Q1W8N3",
		"experience": "6-18 Months",
		"stack": ["Java", "Spring Boot", "SQL Server/PostgreSQL"],
		"salary_range": "25-40k BDT",
		"additional_requirements": [
			"Functional Programming, Reactive Programming (বিশেষতঃ Project Reactor) নিয়ে কাজ করার অভিজ্ঞতা",
			"Dependency Injection / Inversion of Control নিয়ে ক্লিয়ার কনসেপ্ট",
			"Spring Boot এর Autoconfiguration mechanism -কে ম্যাজিক না মনে হওয়া",
			"Microservices Architecture - এ কাজের অভিজ্ঞতা, বিশেষতঃ Service Discovery, API Gateway, Load-balancing, Circuit Breaker, Distributed Tracing ইত্যাদি নিয়ে কাজের অভিজ্ঞতা",
			"GIS (Geographic Information System) এবং PostGIS নিয়ে কাজের অভিজ্ঞতা",
			"Python এ ব্যাসিক স্ক্রিপ্টিংয়ের জ্ঞান। বিশেষতঃ NumPy, Scikit Learn, Geopandas, PyTorch ইত্যাদি",
			"Deep Learning, ANN/CNN নিয়ে আগ্রহ",
			"Additional Tools: Github, Docker, Jira"
		]
	},
	{
		"order": 8,
		"title": "Paid Internship Opportunity",
		"status": "published",
		"duration":'full-time',
		"publish_date": "2024-02-29",
		"expire_date": "",
		"job_post_id": "L7M1P5D9",
		"why_choose_tiller": [
			"Learn from experienced professionals in the field",
			"Contribute to real-world projects that shape cities",
			"Collaborate in a creative and innovative environment",
			"Build a portfolio of impressive urban planning work",
			"Networking opportunities within the industry",
			"A chance to make a difference in your community"
		],
		"requirements": [
			"Enrolled in the URP department",
			"Have basic knowledge of GIS",
			"Passion for urban planning and design and GIS",
			"Excellent communication and teamwork skills",
			"Eagerness to learn and grow in a supportive environment"
		],
		"duration": "3 Months",
		"location": "Mirpur-6, Dhaka",
		"deadline": "27 Oct, 2023"
	},
	{
		"order": 9,
		"title": "Junior Architect",
		"status": "published",
		"duration":'full-time',
		"publish_date": "2024-02-29",
		"expire_date": "",
		"job_post_id": "S9C4F2N6",
		"job_responsibilities": [
			"Work closely with senior architects and other team members to support various aspects of architectural projects and urban designs",
			"Collaborate with the design team to develop architectural concepts and ideas. This may involve creating sketches, 2D drawings, or 3D models to visualize design proposals",
			"Conduct site visits and analysis to gather information about the project location, including topography, climate, surrounding structures, and any site-specific constraints",
			"Create architectural drawings, plans, elevations, and sections using software like AutoCAD, 3DS Max, V-Ray, Lumion, Sketchup, Revit, Illustrator & or other drafting tools. Assist in the development of construction documents",
			"Ensure that designs comply with local building codes, zoning regulations, and other legal requirements",
			"Maintain high standards of quality and accuracy in all architectural work, ensuring that drawings and documents are error-free",
			"Create 3D models and renderings to illustrate design concepts and provide a visual representation of the project",
			"Participate in client meetings and presentations, helping to communicate design ideas and project progress",
			"Stay updated on industry trends, sustainable design practices, and new technologies that can be integrated into architectural projects"
		],
		"educational_requirements": "Minimum bachelor's or master’s degree in architecture from any reputed university",
		"experience_requirements": "At least 1/2 years of experience",
		"additional_requirements": [
			"Strong interest and passion for urban design and planning",
			"Excellent communication and teamwork skills",
			"Ability to think creatively and contribute innovative design ideas"
		],
		"job_location": "Dhaka",
		"salary": "Negotiable",
		"compensation_and_other_benefit": "2 Festival Bonus, Internal & External Training, Leave: Casual, Sick, Maternity Leave, Paternity Leave"
	},
	{
		"order": 10,
		"title": "Paid Internship",
		"status": "published",
		"duration":'full-time',
		"publish_date": "2024-02-29",
		"expire_date": "",
		"job_post_id": "B2V9P8C3",
		"job_description": [
			"GIS Database Preparation",
			"Report Writing",
			"Making relevant presentation",
			"Mapping",
			"And other relevant work with close supervision of the GIS & Planning Department"
		],
		"tenure": "1 Month"
	}
]